import { useI18n } from 'core/i18n/I18nProvider';

export function Pagination({ meta, page, onPageChange }) {
  const { t, dir } = useI18n();
  const current = Number(meta?.current_page || page || 1);
  const last = Number(meta?.last_page || 1);
  if (last <= 1) {
    return null;
  }
  return (
    <nav className="pagination" aria-label={t('layout.navigation')}>
      <button
        type="button"
        className="btn btn-ghost"
        disabled={current <= 1}
        onClick={() => onPageChange(current - 1)}
      >
        {dir === 'rtl' ? t('actions.next') : t('actions.previous')}
      </button>
      <span>{current} / {last}</span>
      <button
        type="button"
        className="btn btn-ghost"
        disabled={current >= last}
        onClick={() => onPageChange(current + 1)}
      >
        {dir === 'rtl' ? t('actions.previous') : t('actions.next')}
      </button>
    </nav>
  );
}
